import React from 'react';
import { BulkDeleteButton } from 'react-admin';

const BulkDeleteActionButtons = (props) => {
  return <BulkDeleteButton {...props} undoable={false} />;
};

export default BulkDeleteActionButtons;
